import React, {useState}  from 'react';
import {
    withStyles,
    Typography,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import Select from 'react-select';

const styles = theme => ({
    formControl: {
      marginTop: theme.spacing.unit,
      width : "100%"
    },
    helperText : {
        marginTop  : 4,
        marginLeft : 12,
    }
});


const selectStyles = {
    control: styles => ({ ...styles, height : 56, fontSize : 12}),
};

/**
 * Componente de select por grupos
 * @author Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const GroupingSelect = ({
    classes,
    value,
    onChange,
    helperText=false,
    placeholder='Seleccione',
    data,
    label,
    disabled=false,
}) => {
const [valueSelect, setValueSelect] = useState({value, label : !value || value=== '' ? null : label});

function handleChange(event){
    setValueSelect(event)
    onChange(event);
}

return(
        <div className={classes.formControl}>
            <Select
                options     = {data}
                value       = {value !== '' && value ? valueSelect : null }
                placeholder = {placeholder}
                styles      = {selectStyles}
                onChange    = {(e) => handleChange(e)}
                components  = {{
                    IndicatorSeparator: () => null
                }}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                    ...theme.colors,
                      text: 'black',
                      primary25: '#bdbdbd',
                      primary: '#009688',
                    },
                })}
                isDisabled={disabled}
            />
            {helperText && 
                <div className={classes.helperText}>
                    <Typography variant="caption">{helperText}</Typography>
                </div>
            }
        </div>
    );
};

GroupingSelect.propTypes = {
    classes     : PropTypes.object,
    label       : PropTypes.string,
    data        : PropTypes.array,
    value       : PropTypes.string,
    onChange    : PropTypes.func,
    placeholder : PropTypes.string,
    helperText  : PropTypes.string, 
}

export default withStyles(styles)(GroupingSelect);


// WEBPACK FOOTER //
// ./src/components/forms/grouping-select.js